import { SectionWrapper } from "../../../../../UI/SectionWrapper/SectionWrapper";
import { Accordion, AccordionSummary, Grid } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { AssetAccordionDetails } from "../../../../ui-components/pageLayout/TableSettingsComponents";
import { CustomFormField, FormField } from "../../../../../Form/FormField";
import CheckboxComponent from "../../../../ui-components/fields/CheckboxComponent";
import React from "react";

const MediaCollectionBasicInformationAccordion: React.FC = () => {
  return (
    <SectionWrapper>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          className="accordion-summary-gray"
        >
          Basic information
        </AccordionSummary>
        <AssetAccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormField
                name="name"
                label="name"
                placeholder="Collection name used in the Admin Portal..."
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name="description"
                label="description"
                placeholder="Collection description used in the Admin Portal..."
              />
            </Grid>
            <Grid item xs={6}>
              <FormField
                name="type"
                label="type"
                placeholder="Collection type..."
              />
            </Grid>
            <Grid item xs={6}>
              <CustomFormField
                name="enabled"
                label="enabled"
                placeholder="Collection enabled..."
                component={CheckboxComponent}
              />
            </Grid>
          </Grid>
        </AssetAccordionDetails>
      </Accordion>
    </SectionWrapper>
  );
};

export default MediaCollectionBasicInformationAccordion;
